import styled, { css } from 'styled-components';
import Image from '@klv/atoms/image';
import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';
import FadeInUp from '../../../atoms/fade-in-up';
import { GradientText } from '../../../atoms/gradient-text';

export const StyledGrid = styled(Grid)`
  width: 100%;
`;

export const FadeInUpGrid = styled(FadeInUp)`
  ${({ theme }) => css`

    grid-column: 1 / -1;
    text-align: center;

    ${theme.screenSize.s768.mediaQuery} {
        grid-column: 3 / 11;
      }
  `}
`;

export const Title = styled(Typography)`
  ${({ theme }) => css`
    ${theme.fonts.sohne.light}
    color: ${theme.colors.white};
    font-size: 2.4rem;
    line-height: 1.15;
    margin: 4.8rem auto 3.6rem;

    ${theme.screenSize.s576.mediaQuery} {
      font-size: 2.8rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      font-size: 3.2rem;
      margin-top: 7.2rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 3.6rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 4rem;
    }
  `}

  strong {
      ${GradientText}
      font-weight: 300;
    }
`;

export const FullColumnImageCtaImage = styled(Image)`
  ${({ theme }) => css`
    grid-column: 1/-1;
    overflow: hidden;
    aspect-ratio: 1/1;
    max-width: 33.6rem;
    width: 100%;
    margin: 0 auto 3.6rem;
    ${theme.screenSize.s576.mediaQuery} {
      max-width: 45rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      max-width: 46.8rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      max-width: 54rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      max-width: 60rem;
    }
  `}
`;

export const IntegrationCtaWrapper = styled.div`
  text-align: center;
  grid-column: 1  / -1;
  margin-bottom: 4.8rem;
  ${({ theme }) => css`
    ${theme.screenSize.s768.mediaQuery} {
      margin-bottom: 6.4rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      margin-bottom: 10.8rem;
    }
  `}
`;
